export enum Position {
  GK = 'GK',
  DF = 'DF',
  MF = 'MF',
  FW = 'FW'
}

export enum GameHeaderState {
  missedGame = 'missedGame',
  playerReadySoon = 'playerReadySoon',
  playerReady = 'playerReady',
  gameInPlayOrReadyToPlay = 'gameInPlayOrReadyToPlay',
  finishedWithPoint = 'finishedWithPoint',
  finishedNoPoints = 'finishedNoPoints',
  futureGame = 'futureGame',
  placeholder = 'placeholder'
}

export enum ReactGACategories {
  entry = 'entry',
  prize = 'prize',
  error = 'error',
  nav = 'nav',
  widget = 'widget'
}

export enum BonusIdentifier {
  DecisionTime = 'decision-time',
  NewSigning = 'new-signing'
}

export enum BonusStatus {
  active = 'active',
  available = 'available',
  unavailable = 'unavailable'
}
